<template>
  <div class="form-group">
    <label
      v-if="label"
      :for="inputId"
      class="form-label"
    >
      {{ label }}
    </label>
    <input
      :id="inputId"
      :value="value"
      :type="type"
      class="form-control"
      :class="validationClass"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
    >
    <div
      v-if="errorMessage"
      class="invalid-feedback d-block"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleInput',
  props: {
    inputId: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    validationClass: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'blur', 'focus'],
};
</script>

<style scoped>
.invalid-feedback.d-block {
  display: block !important;
}
</style>
